import { render, staticRenderFns } from "./PeiFuBiaoZhunView.vue?vue&type=template&id=2b09ecf4&scoped=true"
import script from "./PeiFuBiaoZhunView.vue?vue&type=script&lang=js"
export * from "./PeiFuBiaoZhunView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09ecf4",
  null
  
)

export default component.exports